import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_AM_PD_6W_CCV: string = `
3 as rank,
id,
label,
attributes
`;

export const order_AM_PD_6W_CCV  = 'rank DESC, label';

const getAttributes = (rawName: string) => ({
    cvsequence1: `$.6968.${rawName}`,
    cvsequence2: `$.6969.${rawName}`,
    dpmax: `$.417.${rawName}`,
});

export const buildQuery_AM_PD_6W_CCV: BuildRulesetQuery = ({
   selectFields,
   rawName,
   filter,
   volumetricFlow,
   volumetricFlow2,
   kvs,
   kvs2,
}): [string, string[]] => {

    const attrs = getAttributes(rawName);
    return [
        `WITH products_filtered as (SELECT
                       cast(cv1Attr.value as float) as cvsequence1,
                       cast(cv2Attr.value as float) as cvsequence2,
                       cast(dpmaxAttr.value as float) as dpmax,
                       product.id,
                       label,
                       attributes
                    FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.cvsequence1}`)}) as cv1Attr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.cvsequence2}`)}) as cv2Attr
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `${attrs.dpmax}`)}) as dpmaxAttr
                    WHERE ${filter})
            , user_input as (SELECT cast(? as float) as v100, cast(? as float) as cv, cast(? as float) as v100_2, cast(? as float) as cv_2)
            , bounds as (SELECT
                             cast(floor(cv * 0.89 * 10) as float) / 10 as lower,
                             round(cv * 1.7, 1) as upper,
                             cast(floor(cv_2 * 0.89 * 10) as float) / 10 as lower2,
                             round(cv_2 * 1.7, 1) as upper2,
                             v100,
                             v100_2,
                             cv,
                             cv_2
                         FROM user_input)
            SELECT
                ${selectFields}
                       FROM products_filtered
                       JOIN bounds
                       WHERE products_filtered.cvsequence1 between bounds.lower and bounds.upper
                       AND products_filtered.cvsequence2 between bounds.lower2 and bounds.upper2
                       AND CASE WHEN bounds.v100 > 0 AND  dpmax > 0
                           THEN pow(bounds.v100 / products_filtered.cvsequence1, 2) <= dpmax
                           ELSE true END 
                       AND CASE WHEN bounds.v100_2 > 0 AND  dpmax > 0
                           THEN pow(bounds.v100_2 / products_filtered.cvsequence2, 2) <= dpmax
                           ELSE true END 
        `,
        [volumetricFlow, kvs, volumetricFlow2, kvs2]
    ];
}



